import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';
import { getDataOnRequest } from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const IncidentLogsContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token){
        dispatch(getDataOnRequest(props.userAuth.users_access_token,'GetIncidentLogs','SET_INCIDENT_LOGS'))
      }
    },[props.userAuth.users_access_token])

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData,
    incidentlogs:state.incidentlogs.incidentlogs
  };
};

const composedIncidentLogsContainer = compose(connect(mapStateToProps), IncidentLogsContainer)
export default composedIncidentLogsContainer;
